<template>
  <div>
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="accountSetConfigs"
        @select="selectTest"
        @select-all="selectAll">
      <div slot="toolbar">
        <el-button
            type="primary"
            style="margin-bottom: 10px"
            @click="$refs.editAccountSet.open(0)">
          新建
        </el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="账套编号">
            <el-input v-model.trim="filter.accountSetNo" clearable/>
          </vm-search>
          <vm-search label="账套名称">
            <el-input v-model.trim="filter.accountSetName" clearable/>
          </vm-search>
          <vm-search label="类型">
            <el-select v-model="filter.configType" clearable placeholder="请选择">
              <el-option label="默认" :value="10"/>
              <el-option label="辅助" :value="20"/>
              <el-option label="H5页面" :value="30"/>
              <el-option label="文件" :value="40"/>
            </el-select>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="55"/>
      <el-table-column prop="accountSetNo" align="center" label="账套编号"/>
      <el-table-column prop="accountSetName" align="center" label="账套名称"/>
      <el-table-column prop="configType" align="center" label="类型">
        <template slot-scope="scope">
          <span v-if="scope.row.configType === 10">默认</span>
          <span v-if="scope.row.configType === 20">辅助</span>
          <span v-if="scope.row.configType === 30">H5页面</span>
          <span v-if="scope.row.configType === 40">文件</span>
        </template>
      </el-table-column>
      <el-table-column prop="configValue" align="center" label="地址"/>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="180px">
        <template slot-scope="scope">
          <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>
          <el-button type="primary" @click="$refs.editAccountSet.open(scope.row.pkid)">编辑</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <account-set-edit ref="editAccountSet" @save-success="getList(1)"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import AccountSetEdit from "@/views/SystemInfo/AccountSet/AccountSetEdit";

  export default {
    name: "",
    components: {AccountSetEdit, VmTable, VmSearch},
    data() {
      return {
        idList: "",
        filter: {
          accountSetNo: "",
          accountSetName: "",
          configType: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
        console.log(selection);
      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","accountSetConfigs",row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
